<template>
  <div style="background: #fff; padding: 10px">
    <el-row>
      <el-col
        :span="4"
        style="float: left; overflow: hidden;"
        class="fix-width"
      >
        <el-tree
          v-if="!nobuild"
          style="display: inline-block;width: 75%;"
          :data="data"
          node-key="id"
          :default-expanded-keys="defexpand"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :highlight-current="true"
          ref="tree"
        ></el-tree>
        <p
          v-if="nobuild"
          style="margin-left: 50px;width: 20px;margin-top: 30px;display: inline-block"
        >
          暂无数据
        </p>
        <div
          style="float: right;margin-right: 20px;display: inline-block;width: 1px;background: #8c939d;height: 800px;"
        />
      </el-col>
      <el-col :span="20">
        <!-- 左侧的显示楼栋列表 -->
        <div v-if="!showRightView">
          
          <el-row :gutter="20">
            <el-col
              class="big_col"
              v-for="item in bedListData"
              :key="item.bedId"
            >
              <el-card shadow="always" class="card">
                <div class="card_top">
                  <i class="el-icon-edit top_icon" @click="infoEdit(item);"></i>
                </div>
                <div class="card_text">
                  房间编号: <span>{{ item.roomNo }}</span>
                </div>
                <div class="card_text">
                  床位编号: <span>{{ item.bedNo }}</span>
                </div>
                <div class="card_text">
                  床位别名: <span>{{ item.bedAlias }}</span>
                </div>
                <div class="card_text">
                  老人姓名: <span>{{ item.oldName }}</span>
                </div>
                <div class="card_text">
                  紧急联系人:
                  <span v-show="item.egNamea != null">{{item.egNamea}}</span>
                </div>
                <div class="card_text">
                  紧急联系人电话:
                  <span v-show="item.egPhonea != null">{{item.egPhonea}}</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>


    <!-- 床位调整 -->
    <el-dialog
      title="床位调整"
      :visible.sync="editRoomDialogVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        :model="editRoomForm"
        label-width="120px"
        :rules="addRoomRules"
        ref="editRoomForm"
      >
        <el-form-item label="床位编号" prop="bedNo">
          <el-input
            v-model.trim="editRoomForm.bedNo"
            :maxlength="3"
            auto-complete="off"
            readonly
            style="width: 374px"
          >
          </el-input>
        </el-form-item>
        
        <el-form-item label="入住长者" prop="oldName">
          <el-autocomplete
            v-model.trim="editRoomForm.oldName"
            auto-complete="off"
            placeholder="请输入长者姓名搜索"
            style="width: 374px"
            :fetch-suggestions="querySearchAsync"
            @select="handleOlderSelect"
          ></el-autocomplete>
        </el-form-item>

        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="editRoomSubmit('editRoomForm');"
          >确定</el-button
        >
        <el-button @click.native="editRoomDialogVisible = false;"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 查询机构内的房间,根据楼栋楼层来筛选
export default {
  name: "RoomOldSetting",
  components: {
  },
  data() {
    return {
      layout: JSON.parse(JSON.stringify([])),
      draggable: false,
      resizable: false,
      mirrored: false,
      addBuildLoading: false,
      responsive: false,
      rowHeight: 36,
      colNum: 36,
      showEditView: false,
      saveText: "编辑", //
      nobuild: false,
      data: [],
      oldmanList:[],
      defexpand: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      currentRoomId: "",
      getRoomJson: "",
      addRoomLeft: "",
      showRightView: false, //显示楼栋视图操作
      bedListData: [
        {
          roomId: 0,
          bedId: 0,
          bedNo: 0,
          roomNo: "",
          oldmanId: null,
          oldName: null,
          egNamea: null,
          egPhonea: null,
          bedStatus: 0,
          hasToilet: 0,
          oldStatus: null,
          bedDirection: null,
          bedAlias: null,
          levelCareId: "",
          levelCareName: "",
          isPayed: null
        }
      ],
      btnLoading: false,
      addRoomVisible: false,
      showSaveBtn: true,
      nowfloorList: [], //当前楼层的下拉选框
      addRoomForm: {},
      bedTypeList: [
      ],
      addRoomRules: {
      },
      editRoomDialogVisible: false,
      editRoomForm: {}
    };
  },
  methods: {

  /* 
    根据模糊查询老人返回老人id
  */
  handleOlderSelect(item) {
    this.editRoomForm.oldManId = item.oldmanId;
  },
  /* 
    模糊查询老人
  */
  querySearchAsync(queryString, cb) {
      let param = {
        oldName: queryString,
        pageNum:1,
        pageSize:10,
        isHaveBed:0, //无床位老人
      };
      this.$postJson("omc/Oldman/queryOldWithBed", param).then((res) => {
        this.oldmanList = res.result.list;
        var list = [{}];
        if (res.result.list.length > 0) {
          for (let i of res.result.list) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result.list;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.editRoomForm.oldName = "";
          }, 1000);
        }
      });
    },

    //   获取护理等级列表
    getSelfcareStatusList() {
      this.bedTypeList = [];
      let params = {
        pageNum: 1,
        pageSize: 999,
        groupId: Number(sessionStorage.getItem("groupId"))
      };
      this.$postJson("omc/levelCare/select", params).then(res => {
        if (res.code == 200) {
          this.bedTypeList = res.result.list;
        } else {
          this.bedTypeList = [];
        }
      });
    },
    //获取楼栋列表
    getBuildList() {
      this.$post("omc/Building/showAlls").then(res => {
        console.log(res);
        var treeData = [];
        for (var i = 0; i < res.length; i++) {
          var floorNum = res[i].floorNum; //楼层数
          var item = {
            label: res[i].buildingName,
            id: res[i].buildingId,
            buildInfo: res[i],
            level: 0
          };
          console.log(item,"itemitem");
          // 自己显示第一个楼栋的全部床位,展开第一个楼栋
          if (i == 0) {
            this.defexpand.push(res[i].buildingId);
            this.getBedData({
              buildingId: res[i].buildingId
            });
          }
          console.log(res[i].floorList);
          if (res[i].floorList != null) {
            var children = [];
            //有房间的楼层列表
            for (var j = 0; j < res[i].floorList.length; j++) {
              var newChildren = [];
              if (
                res[i].floorList[j] != null &&
                res[i].floorList[j].roomList != null
              ) {
                //有床位的房间列表
                for (var k = 0; k < res[i].floorList[j].roomList.length; k++) {
                  newChildren.push({
                    //床位id
                    id: res[i].floorList[j].roomList[k].roomId,
                    label: res[i].floorList[j].roomList[k].roomNo,
                    buildId: res[i].floorList[j].roomList[k].buildingId,
                    floorNo: res[i].floorList[j].roomList[k].floorNo,
                    buildInfo: res[i],
                    level: 2
                  });
                }
                children.push({
                  buildId: res[i].buildingId,
                  id: res[i].buildingId + "" + res[i].floorList[j].floorNo,
                  floorNo: res[i].floorList[j].floorNo,
                  label: res[i].floorList[j].floorNo + "层",
                  buildInfo: res[i],
                  children: newChildren,
                  level: 1
                });
              }
            }
            children.reverse();
            item.children = children;
            treeData.push(item);
          }
        }
        console.log(treeData);
        this.data = treeData;
      });
    },
    directToStr(number) {
      if (number == 1) {
        return "东";
      } else if (number == 2) {
        return "西";
      } else if (number == 3) {
        return "南";
      } else if (number > 3) {
        return "北";
      }
    },
    bedNumToType(number) {
      for (var i = 0; i < this.bedTypeList.length; i++) {
        if (this.bedTypeList[i].value * 1.0 == number * 1.0) {
          if (this.bedTypeList[i].label.length > 8) {
            return this.bedTypeList[i].label.substring(0, 8);
          } else {
            return this.bedTypeList[i].label;
          }
        }
      }
      return "--";
    },
    correctCareLevelId(number) {
      for (var i = 0; i < this.bedTypeList.length; i++) {
        if (this.bedTypeList[i].id * 1.0 == number * 1.0) {
          return this.bedTypeList[i].id;
        }
      }
      return "";
    },
    //获取房间列表
    getBedData(json) {
      this.getRoomJson = json;
      this.$post("omc/Bed/queryBedInfo", json, "", "json").then(
        res => {
          this.bedListData = res;
        },
        err => {
          this.$message.error(err.message);
        }
      );
    },
    //点击获取数据
    handleNodeClick(data) {
      var json = "";
      if (data.level == 0) {
        //点击楼栋
        this.showSaveBtn = false;
        this.showEditView = false;
        json = {
          buildingId: data.buildInfo.buildingId
        };
      } else if (data.level == 1) {
        this.showEditView = false;
        this.showSaveBtn = false;
        json = {
          buildingId: data.buildInfo.buildingId,
          floorNo: data.floorNo
        };
      } else if (data.level == 2) {
        this.showEditView = true;
        this.showSaveBtn = true;
        this.currentRoomId = data.id;
        json = {
          buildingId: data.buildInfo.buildingId,
          floorNo: data.floorNo,
          roomId: data.id
        };
        // this.showRightView = true;
        if (this.showRightView) {
          this.editView();
        }
      }
      this.getBedData(json);
    },
    getOldManList(){
      let params = {
        pageNum:1,
        pageSize:10,
        serviceType:1, //入院老人
        isHaveBed:0, //无床位老人
      };
      this.$postJson("omc/Oldman/queryOldWithBed",params).then(res => {
        this.oldmanList = res.result.list;
      });
    },
    infoEdit(item) {
      this.editRoomDialogVisible = true;
      this.editRoomForm = Object.assign({}, item);
      this.editRoomForm.bedNo = item.roomNo+'-'+item.bedNo;
      this.$nextTick(() => {
        this.$refs["editRoomForm"].resetFields();
        this.editRoomForm = Object.assign({}, item);
        this.editRoomForm.bedNo = item.roomNo+'-'+item.bedNo;
      });
      this.getOldManList();
    },
    editRoomSubmit(formName) {
      // 给老人换床位;
      let params = {
        oldmanId:this.editRoomForm.oldManId,
        bedId:this.editRoomForm.bedId
      };
      this.$postForm("omc/Oldman/changeBedOldId", params).then(res => {
        if(res.code == 200){
          this.getBedData(this.getRoomJson)
          this.editRoomDialogVisible = false;
        }else{
          this.$message.error(res.message);
        }
      });
    },
  },
  mounted() {
    this.getBuildList();
    this.getOldManList();
    this.getSelfcareStatusList();
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.vue-grid-item.cssTransforms {
  background: #1d8ce0;
}

.centertext {
  position: absolute;
  left: 50%;
  top: 50%;
  color: white;
  font-size: 16px;
  transform: translate(-50%, -50%);
}

.box-card {
  font-size: 16px;
}
.el-card__body {
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
}
.buttontxt {
  width: 49%;
  text-align: center;
  display: inline-block;
  border: 0.5px solid #e4e4e4;
  font-size: 16px;
  padding-bottom: 8px;
  padding-top: 5px;
  cursor: pointer;
}
.big_col {
  width: 300px;
  margin-top: 10px;
}
.card {
  width: 280px;
  border: 1px solid #3a77e2;
  border-radius: 10px;
  padding-bottom: 8px;
}
.card_top {
  background: #3a77e2;
  width: 100%;
  height: 40px;
}
.card ::v-deep .el-card__body {
  padding: 0px;
}

.top_icon {
  float: right;
  color: white;
  font-size: 22px;
  text-align: center;
  margin-top: 9px;
  cursor: pointer;
  margin-right: 10px;
}
.card_text {
  padding-left: 10px;
  font-size: 15px;
  height: 20px;
  padding-top: 4px;
}

.el-tree-node {
  width: 100%;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(51, 122, 183);
  width: 120px;
  color: #fff;
  border-radius: 5px;
}
//  ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
</style>
